export const isAuthCallbackPage = () => /^.*\/authorization(?:\?.*)?$/.test(document.location.href);
